export default __webpack_public_path__ + "static/media/competition_last.13fbd438.png";